import React from "react";
import { useTranslation } from "react-i18next";

import * as SC from "./AttentionBox.styled";
import DataVizStore from "../../../../Stores/DataVizStore";
import { withRefluxStore } from "../../../../Stores";
import usePrevious from "../../../../hooks/usePrevious";
import { MetricTypes } from "../enums/metrics";

import CTRBox from "./CTRBox/CTRBox";
import AttentionTitle from "./AttentionTitle/AttentionTitle";

const AttentionBox = ({
  cardKey = "",
  metricHovered,
  interactionMetrics,
  selectedChannel,
  expanded
}) => {
  const { t } = useTranslation();

  const previousExpanded = usePrevious(expanded);

  const metricValues = interactionMetrics ? interactionMetrics.ctr.totalValue : "";
  const showCTRBox = cardKey === "engagementMetrics" && metricHovered === MetricTypes.CTR;

  return (
    <SC.AttentionBoxWrapper isVisible={expanded} wasVisible={previousExpanded}>
      <SC.DescriptionSection>
        <SC.SectionTitle>{t("Description")}</SC.SectionTitle>
        <SC.MetricDescriptionWrapper>
          <SC.Title>
            <AttentionTitle metricValue={metricValues} channel={selectedChannel} />
          </SC.Title>
          <SC.Message>
            {showCTRBox && <CTRBox metricValue={metricValues} channel={selectedChannel} />}
          </SC.Message>
        </SC.MetricDescriptionWrapper>
      </SC.DescriptionSection>
    </SC.AttentionBoxWrapper>
  );
};

export default withRefluxStore(
  AttentionBox,
  [DataVizStore],
  ["metricHovered", "interactionMetrics", "selectedChannel"]
);
